import { updateCartProducts } from "../../api/action/cart";
import { addShoppingCartItems } from "../../api/action/user";

// const authState = useSelector((state) => state?.auth?.data);
const companyDomain = localStorage.getItem("domainType") || null;

const getStoredCartProducts = () => {
  try {
    return JSON.parse(localStorage.getItem("cartProducts") || "[]");
  } catch {
    return [];
  }
};

const getStoredShoppingCart = () => {
  try {
    return JSON.parse(localStorage.getItem("shoppingCartData") || "{}");
  } catch {
    return {};
  }
};

export const addProductToCart = async ({
  productDetails,
  quantity,
  addToCart,
  updateCart,
  navigate,
}) => {

  const existingProducts = getStoredCartProducts();
  const existingCart = getStoredShoppingCart();

  const isProductInCart = existingProducts.some(
    (item) => item?.product?.primaryId === productDetails.primaryId
  );

  const retailReq = {
    quantity: quantity,
    totalPrice: productDetails.price.priceAmt * quantity,
    product: {
      name: productDetails.name,
      description: productDetails.description,
      code: productDetails.code,
      _id: productDetails._id,
      primaryId: productDetails.primaryId,
      bulkOrderEnabled: Boolean(productDetails.bulkOrderEnabled),
    },
  };

  if (!isProductInCart) {
    try {
      await addToShoppingCart(retailReq, navigate);
      addToCart(retailReq);
    } catch (err) {
      return err;
    }
  } else {
    const updatedProduct = existingProducts.map((curElem) => {
      if (curElem.product.primaryId === productDetails.primaryId) {
        const newAmount = curElem.totalPrice + retailReq.totalPrice;
        let newQty = curElem.quantity + retailReq.quantity;
        if (newQty >= 10) {
          newQty = 10;
        }
        return {
          ...curElem,
          quantity: newQty,
          totalPrice: newAmount,
        };
      } else {
        return curElem;
      }
    });
    const newcart = { ...existingCart, productList: updatedProduct };
    updateProductQuantity(newcart, navigate)
      .then(() => {
        updateCart(updatedProduct);
      })
      .catch((err) => {
        return err;
      });
  }
};

export const addCoursesToCart = async ({
  courseDetails,
  quantity,
  addToCart,
  scheduledProduct,
  navigate,
}) => {
  const existingProducts = getStoredCartProducts();
  const isProductInCart = (existingProducts || []).some(
    // (item) => item.scheduledProduct.product._id === courseDetails._id
    (item) => item?.scheduledProduct?.product?.primaryId === courseDetails.primaryId
  );
  if (!isProductInCart) {
    const schduledReq = {
      quantity: quantity,
      totalPrice: courseDetails.price.priceAmt,
      scheduledProduct: {
        deleted: scheduledProduct[0].deleted,
        hasSchedule: scheduledProduct[0].hasSchedule,
        status: scheduledProduct[0].status,
        product: {
          deleted: courseDetails.deleted,
          name: courseDetails.name,
          code: courseDetails.code,
          _id: courseDetails._id,
          primaryId: courseDetails.primaryId,
        },
        schedule: {
          deleted: scheduledProduct[0].schedule.deleted,
          scheduleCode: scheduledProduct[0].schedule.scheduleCode,
        },
        period: {
          deleted: scheduledProduct[0].period.deleted,
          effectiveStartDate: scheduledProduct[0].period.effectiveStartDate,
          effectiveEndDate: scheduledProduct[0].period.effectiveEndDate,
        },
        _id: scheduledProduct[0]._id,
        primaryId: scheduledProduct[0].primaryId,
      },
    };
    addToShoppingCart(schduledReq, navigate).catch((err) => {
      return err;
    });
    addToCart(schduledReq);
  } else {
    return "Product already in the cart";
  }
};

export const addToShoppingCart = async (lineItem) => {

  try {
    const response = await addShoppingCartItems(lineItem);

    // if (response) {
    //   navigate("/cart");
    //   window.location.href = "/confirm-book";

    // }

    if (response) {
      if (companyDomain === 'FLEX_OFFICE') {
        window.location.href = "/cart";
      }
    }

    return response;
  } catch (error) {
    return error;
  }
};





const updateProductQuantity = async (shoppingCart, navigate) => {
  try {
    const response = await updateCartProducts(shoppingCart);
    if (response) {
      navigate("/cart");
    }
  } catch (error) {
    return error;
  }
};
